import { render, staticRenderFns } from "./SelectAdminHubFoodClaim.vue?vue&type=template&id=1b3e4ccd&"
import script from "./SelectAdminHubFoodClaim.vue?vue&type=script&lang=js&"
export * from "./SelectAdminHubFoodClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports